import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import RoleProtectedRoute from "../components/shared/RoleProtectedRoute";
import { ROLES } from "../constants/roles";

// Lazy load admin monitoring components
const AdminHistory = lazy(() => import("../pages/Admin/AdminHistory"));
const AdminLists = lazy(() => import("../pages/Admin/AdminLists"));
const RegisteredUsers = lazy(() => import("../pages/Admin/RegisteredUsers"));
const ReturnRequests = lazy(() => import("../pages/Admin/ReturnRequests"));
const SellerOnboardingCreate = lazy(() => import("../pages/Admin/SellerOnboardingCreate"));
const ServiceProviderOnboardingCreate = lazy(() => import("../pages/Admin/ServiceProviderOnboardingCreate"));

/**
 * Admin Monitoring Routes Configuration
 * Defines routes for super admin monitoring features
 * Only accessible by Super Admin users
 */
export default function AdminMonitoringRoutes() {
  return (
    <Routes>
      {/* Admin Login/Logout History */}
      <Route
        path="/history"
        element={
          <RoleProtectedRoute 
            requiredRole={ROLES.SUPER_ADMIN}
            allowHigherRoles={false}
          >
            <AdminHistory />
          </RoleProtectedRoute>
        }
      />

      {/* Admin Lists */}
      <Route
        path="/admins"
        element={
          <RoleProtectedRoute 
            requiredRole={ROLES.SUPER_ADMIN}
            allowHigherRoles={false}
          >
            <AdminLists />
          </RoleProtectedRoute>
        }
      />

      {/* Registered Users List */}
      <Route
        path="/users"
        element={
          <RoleProtectedRoute 
            requiredRole={ROLES.SUPER_ADMIN}
            allowHigherRoles={false}
          >
            <RegisteredUsers />
          </RoleProtectedRoute>
        }
      />

      {/* Return Requests Monitoring */}
      <Route
        path="/return-requests"
        element={
          <RoleProtectedRoute 
            requiredRole={ROLES.SUPER_ADMIN}
            allowHigherRoles={false}
          >
            <ReturnRequests />
          </RoleProtectedRoute>
        }
      />

      {/* Onboarding: Seller & Service Provider creation */}
      <Route
        path="/onboarding/sellers/create"
        element={
          <RoleProtectedRoute 
            requiredRole={ROLES.SUPER_ADMIN}
            allowHigherRoles={false}
          >
            <SellerOnboardingCreate />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/onboarding/service-providers/create"
        element={
          <RoleProtectedRoute 
            requiredRole={ROLES.SUPER_ADMIN}
            allowHigherRoles={false}
          >
            <ServiceProviderOnboardingCreate />
          </RoleProtectedRoute>
        }
      />

      {/* Default redirect to history */}
      <Route
        path="/*"
        element={
          <RoleProtectedRoute 
            requiredRole={ROLES.SUPER_ADMIN}
            allowHigherRoles={false}
          >
            <AdminHistory />
          </RoleProtectedRoute>
        }
      />
    </Routes>
  );
}
